import {RootState} from '../rootReducer';

export const incidentSelector = (state: RootState) => state.incident;

export const incidentListSelector = (state: RootState) => state.incident.list;
